var PaymentMethod = /** @class */ (function () {
    function PaymentMethod(data) {
        this.paymentMethodKey = null;
        this.paymentType = null;
        this.paymentFee = 0;
        this.cbuNumber = null;
        this.creditCardType = null;
        this.creditCardNumber = null;
        this.firstDueDate = new Date();
        this.collector = {
            code: null,
            description: null
        };
        this.sendCouponsBy = {
            code: null,
            description: null
        };
        this.icon = null;
        this.finalAmount = null;
        this.quoteAmount = null;
        this.title = null;
        this.fee = null;
        if (data) {
            Object.assign(this, data);
        }
    }
    return PaymentMethod;
}());
export { PaymentMethod };
